import { Link } from 'gatsby'
import React from 'react'
import CompareContainer from 'src/components/template/compare/components/modules/Container'
import SectionText from 'src/components/template/compare/components/modules/SectionText'
import { breakpointQuery } from 'src/components/template/compare/constants/breakpoint'
import styled from 'styled-components'

const CompareInterlinkingCard = ({ data }) => {
  return (
    <StyledCompareInterlinkingCard>
      <Link to={data.link}>
        <h4 className="interlinking-title">{data.name}</h4>
        <p className="interlinking-text">Fubo vs {data.competitor}</p>
        <div className="interlinking-button">Learn More</div>
      </Link>
    </StyledCompareInterlinkingCard>
  )
}

const StyledCompareInterlinkingCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  border-radius: 8px;
  background: radial-gradient(94.79% 94.79% at 50% 5.21%, #0449b0 0%, #00183c 79.06%);
  > a {
    width: 100%;
    height: 100%;
    padding: 30px 10px;
    box-sizing: border-box;
    ${breakpointQuery.mobile} {
      padding: 26px 10px;
    }
  }
  .interlinking-title {
    color: #fff;
    text-align: center;

    font-size: 26px;
    font-style: normal;
    font-weight: 800;
    line-height: 48px; /* 184.615% */
    ${breakpointQuery.mobile} {
      font-size: 24px;
    }
  }
  .interlinking-text {
    margin-bottom: 25px;
    color: #5a97f1;
    text-align: center;

    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 142.857% */
    letter-spacing: 0.14px;
    ${breakpointQuery.mobile} {
      font-size: 12px;
    }
  }
  .interlinking-button {
    display: flex;
    width: 100%;
    padding: 10.34px 13.786px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border-radius: 86.165px;
    background: rgba(200, 204, 223, 0.1);
    box-sizing: border-box;

    color: var(--white, #fff);
    text-align: center;

    /* Label/Label-M (Bold) */

    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px; /* 128.571% */
    letter-spacing: 0.14px;
  }
`

const CompareInterlinkingSection = () => {
  const comparePageList = [
    {
      competitor: 'Sling TV',
      name: 'Sling TV',
      image: '',
      link: '/compare/fubo-vs-sling/',
    },
    {
      competitor: 'YouTube TV',
      name: 'YouTube TV',
      image: '',
      link: '/compare/fubo-vs-youtubetv/',
    },
    {
      competitor: 'DirecTV',
      name: 'DirecTV',
      image: '',
      link: '/compare/fubo-vs-directv/',
    },
    {
      competitor: 'Philo',
      name: 'Philo',
      image: '',
      link: '/compare/fubo-vs-philo/',
    },
    {
      competitor: 'Cable',
      name: 'Cable',
      image: '',
      link: '/compare/fubo-vs-cable/',
    },
    {
      competitor: 'Cox',
      name: 'Cox',
      image: '',
      link: '/compare/fubo-vs-cox/',
    },
    {
      competitor: 'Verizon Fios',
      name: 'Verizon Fios',
      image: '',
      link: '/compare/fubo-vs-verizon-fios/',
    },
    {
      competitor: 'Xfinity',
      name: 'Xfinity',
      image: '',
      link: '/compare/fubo-vs-xfinity/',
    },
    {
      competitor: 'Spectrum',
      name: 'Spectrum',
      image: '',
      link: '/compare/fubo-vs-spectrum/',
    },
    {
      competitor: 'Optimum',
      name: 'Optimum',
      image: '',
      link: '/compare/fubo-vs-optimum/',
    },
  ]

  return (
    <StyledCompareInterlinkingSection>
      <CompareContainer className="content">
        <SectionText heading="See how Fubo stacks up against the competition" />
        <div className="interlinking-card-container">
          {comparePageList.map((item, index) => {
            return <CompareInterlinkingCard key={index} data={item} />
          })}
        </div>
      </CompareContainer>
    </StyledCompareInterlinkingSection>
  )
}

export default CompareInterlinkingSection

const StyledCompareInterlinkingSection = styled.section`
  .interlinking-card-container {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 10px;
    ${breakpointQuery.mobile} {
      grid-template-columns: repeat(2, 1fr);
      ${'' /* gap: 5px; */}
    }
  }
`
